export function User3FillIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.00033 5.83268C8.28899 5.83268 9.33366 4.78801 9.33366 3.49935C9.33366 2.21068 8.28899 1.16602 7.00033 1.16602C5.71166 1.16602 4.66699 2.21068 4.66699 3.49935C4.66699 4.78801 5.71166 5.83268 7.00033 5.83268Z"
        fill="currentColor"
      />
      <path
        d="M7.00033 12.2507C9.25549 12.2507 11.0837 11.206 11.0837 9.91732C11.0837 8.62865 9.25549 7.58398 7.00033 7.58398C4.74516 7.58398 2.91699 8.62865 2.91699 9.91732C2.91699 11.206 4.74516 12.2507 7.00033 12.2507Z"
        fill="currentColor"
      />
    </svg>
  );
}
